<div class="rmd__header">
  <span class="rmd__title">Round Details</span>
  <span class="rmd__gameid">#{{ round().gameid }}</span>
</div>

<div class="rmd__divider"></div>

<div class="rmd__list">
  @for (bet of round().bets; track bet.steamid) {
  @let winner = round().winner?.steamid === bet.steamid;
  <div
    class="rmd__card"
    [class.rmd__card--winner]="winner"
    [style.--card-color]="winner ? (round().winner?.user_color ?? 'var(--primary)') : 'transparent'"
  >
    <div class="rmd__card-row">
      <div
        class="rmd__player"
        [style.cursor]="isBot(bet) ? 'default' : 'pointer'"
        (click)="isBot(bet) ? null : contextMenuService.open($event, { user: bet, hideMute: true })"
      >
        <img
          class="rmd__avatar"
          [src]="bet.avatar"
          [alt]="bet.name"
          [style.border-color]="bet.user_color"
        />
        @if (isBot(bet)) { <app-bot-tag /> } @else { <app-user-level [level]="bet.level" /> }
        <span class="rmd__name">{{ botName(bet.name) }}</span>
      </div>
      @if (winner) {
      <div class="rmd__trophy">
        <svg-icon src="assets/icons/jackpot/cup.svg" />
      </div>
      }
      <div class="rmd__stats">
        <div class="rmd__pot">
          <app-balance-icon [balance]="'skins'" />
          <span class="rmd__value">{{ bet.total_value | number : "1.2-2" }}</span>
        </div>
        <div class="rmd__stat-divider"></div>
        <div class="rmd__chance-wrap">
          <svg-icon
            class="flex items-center justify-center s-14"
            src="assets/icons/shared/trend-up.svg"
          />
          <span class="rmd__chance">{{ bet.chances | number : "1.2-2" }}%</span>
        </div>
      </div>
    </div>

    @if (bet.skins.length) {
    <div class="rmd__slider-wrap">
      <app-jackpot-skins-slider [skins]="bet.skins" align="start" />
    </div>
    }
  </div>
  }
</div>
